(function () {
  const cache = {};

  function normalize(v) {
    return String(v || '').trim().toUpperCase();
  }

  function log() {
    console.log('[RING]', ...arguments);
  }

  async function loadJSON(url) {
    if (cache[url]) return cache[url];

    const res = await fetch(url, { credentials: 'same-origin' });
    if (!res.ok) throw new Error(`JSON load failed: ${res.status}`);

    const data = await res.json();
    cache[url] = Array.isArray(data) ? data : [];
    log('Loaded JSON entries:', cache[url].length);

    return cache[url];
  }

  function getValue(selector, id) {
    const field = selector.querySelector('#' + id);
    if (!field) return '';

    const active = field.querySelector('.is-active');
    if (active) return normalize(active.value);

    const select = field.querySelector('.gifteringer-selector__select');
    if (select) return normalize(select.value);

    return '';
  }

  function getState(selector) {
    return {
      ring_size: getValue(selector, 'ring_selector_size'),
      width: getValue(selector, 'ring_selector_width'),
      surface: getValue(selector, 'ring_selector_surface'),
      material: getValue(selector, 'ring_selector_material')
    };
  }

  function findMatch(rings, state) {
    return rings.find((r) =>
      normalize(r.ring_size) === state.ring_size &&
      normalize(r.width) === state.width &&
      normalize(r.surface) === state.surface &&
      normalize(r.material) === state.material
    );
  }

  function getSectionElement(selector) {
    return selector.closest('[id^="shopify-section-"]');
  }

  function buildTargetUrl(match) {
    if (match.url) return match.url;

    const sku = String(match.sku || '').trim();
    if (!sku) return null;

    return `/products/${sku.toLowerCase()}?view=gifteringer`;
  }

  async function silentReload(selector, url) {
    const currentSection = getSectionElement(selector);

    if (!currentSection) {
      window.location.assign(url);
      return;
    }

    const currentSectionId = currentSection.id;
    log('Reloading section:', currentSectionId, 'from', url);

    try {
      currentSection.classList.add('is-loading');

      const res = await fetch(url, {
        credentials: 'same-origin',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      if (!res.ok) {
        throw new Error(`Product fetch failed: ${res.status}`);
      }

      const html = await res.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const newSection = doc.getElementById(currentSectionId);

      if (!newSection) {
        log('Could not find matching section in fetched HTML, fallback redirect');
        window.location.assign(url);
        return;
      }

      currentSection.replaceWith(newSection);
      window.history.pushState({}, '', url);

      document.dispatchEvent(
        new CustomEvent('shopify:section:load', {
          detail: { sectionId: currentSectionId.replace('shopify-section-', '') }
        })
      );

      initGifteringerSelector(document);
    } catch (err) {
      console.error('[RING] Silent reload failed:', err);
      window.location.assign(url);
    }
  }

  async function handleChange(selector) {
    try {
      const jsonUrl = selector.dataset.jsonUrl;
      if (!jsonUrl) {
        log('Missing data-json-url');
        return;
      }

      const rings = await loadJSON(jsonUrl);
      const state = getState(selector);

      log('State:', state);

      if (!state.ring_size || !state.width || !state.surface || !state.material) {
        log('Missing values');
        return;
      }

      const match = findMatch(rings, state);
      log('Match:', match);

      if (!match) {
        log('No match found');
        return;
      }

      const targetUrl = buildTargetUrl(match);

      if (!targetUrl) {
        log('Missing sku/url in JSON entry');
        return;
      }

      log('Target URL:', targetUrl);

      await silentReload(selector, targetUrl);
    } catch (err) {
      console.error('[RING] handleChange failed:', err);
    }
  }

  function bindSelector(selector) {
    if (!selector || selector.dataset.ready === 'true') return;
    selector.dataset.ready = 'true';

    selector.addEventListener('click', function (e) {
      const btn = e.target.closest('.gifteringer-selector__option');
      if (!btn) return;

      const group = btn.closest('.gifteringer-selector__options');
      if (!group) return;

      group.querySelectorAll('.gifteringer-selector__option').forEach((b) => {
        b.classList.remove('is-active');
      });

      btn.classList.add('is-active');
      handleChange(selector);
    });

    selector.addEventListener('change', function (e) {
      const select = e.target.closest('.gifteringer-selector__select');
      if (!select) return;

      handleChange(selector);
    });
  }

  function initGifteringerSelector(root) {
    const scope = root || document;
    const selectors = scope.querySelectorAll('.gifteringer-selector');

    selectors.forEach((selector) => {
      bindSelector(selector);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initGifteringerSelector(document);
  });

  document.addEventListener('shopify:section:load', function () {
    initGifteringerSelector(document);
  });

  window.addEventListener('popstate', function () {
    window.location.reload();
  });
})();